import { coreSettings, initializeUtilsCore } from 'app-components/utils/core';

import './configInit';
import platform from './platform';

// todo perhaps remove altogether?
const History = {
  navigate: null,

  push: (page, ...other) => History.history.push(page, ...other),
  replace: (page, ...other) => History.history.replace(page, ...other),
};
initializeUtilsCore({
  history: History,
  platform,
  localStorage,
});
coreSettings.fetchDebounceTimeout = 3000;
